import React, { useState } from "react";
import { FiChevronsDown, FiChevronsUp } from "react-icons/fi";
import { Tooltip } from "@mui/material";
import { convertToUTCString } from "../../../../utils/helpers/helper";
import CallDetailsForm from "./CallDetailsForm";

const LeadDetailsSidebar = ({ profilingData: profiling }) => {
  const [openAccordion, setOpenAccordion] = useState(true);
  const toggleAccordion = () => {
    setOpenAccordion(!openAccordion);
  };

  return (
    <div className="col-12 theiaStickySidebar">
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center">
            <h6 className="mb-3 fw-semibold fs-4 ">Profiling Form Details</h6>
            <Tooltip
              title={openAccordion ? "Collapse Details" : "Expand Details"}
            >
              <div style={{ cursor: "pointer" }} onClick={toggleAccordion}>
                {openAccordion ? (
                  <FiChevronsUp size={18} />
                ) : (
                  <FiChevronsDown size={18} />
                )}
              </div>
            </Tooltip>
          </div>

          {openAccordion && (
            <>
              <h6 className="mb-1 mt-1 fw-semibold fs-5 text-decoration-underline">
                Basic Details
              </h6>
              <div className="row mb-2">
                <InfoItem label="Full Name" value={profiling?.fullName} />
                <InfoItem label="Email" value={profiling?.email} />
                <InfoItem label="Mobile" value={profiling?.mobile} />
                <InfoItem label="Course" value={profiling?.course} />
                <InfoItem label="Medium" value={profiling?.medium} />
                <InfoItem label="Status" value={profiling?.status} />
                <InfoItem
                  label="Enrolled On"
                  value={convertToUTCString(profiling?.enrolledOn)}
                />
              </div>
              <hr />

              {/* Client Details */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Client Details
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Full Name"
                  value={profiling?.clientDetails?.fullName}
                />
                <InfoItem
                  label="Mobile"
                  value={profiling?.clientDetails?.registeredMobileNo}
                />
                <InfoItem
                  label="Email"
                  value={profiling?.clientDetails?.registeredEmailAddress}
                />
                <InfoItem
                  label="Gender"
                  value={profiling?.clientDetails?.gender}
                />
                <InfoItem label="Age" value={profiling?.clientDetails?.age} />
                <InfoItem
                  label="Client Code"
                  value={profiling?.clientDetails?.clientCode}
                />
                <InfoItem label="City" value={profiling?.clientDetails?.city} />
                <InfoItem
                  label="State"
                  value={profiling?.clientDetails?.state}
                />
                <InfoItem
                  label="Nominee"
                  value={profiling?.clientDetails?.nomineeFullName}
                />
                <InfoItem
                  label="Stock Market Experience (in years)"
                  value={profiling?.clientDetails?.stockMarketExperience}
                />
              </div>
              <hr />

              {/* Monthly Income */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Monthly Income
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Salary"
                  value={profiling?.monthlyIncome?.salary}
                />
                <InfoItem
                  label="Business"
                  value={profiling?.monthlyIncome?.business}
                />
                <InfoItem
                  label="Agriculture"
                  value={profiling?.monthlyIncome?.agriculture}
                />
                <InfoItem
                  label="Interest"
                  value={profiling?.monthlyIncome?.interest}
                />
                <InfoItem
                  label="otherEarnings"
                  value={profiling?.monthlyIncome?.otherEarnings}
                />
              </div>

              {/* Rental Amounts */}
              {profiling?.monthlyIncome?.rentalAmounts?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">Rental Income</h6>
                  {profiling.monthlyIncome.rentalAmounts.map(
                    (rental, index) => (
                      <div key={index} className="row">
                        <InfoItem label="Type" value={rental.type} />
                        <InfoItem label="Amount" value={rental.amount} />
                      </div>
                    ),
                  )}
                </div>
              )}
              <hr />

              {/* Monthly Expenses */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Monthly Expenses
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Flat Type"
                  value={profiling?.monthlyExpenses?.flatType}
                />
                <InfoItem
                  label="Flat Amount"
                  value={profiling?.monthlyExpenses?.flatAmount}
                />
                <InfoItem
                  label="Car EMI"
                  value={profiling?.monthlyExpenses?.carEmi}
                />
                <InfoItem
                  label="Bike EMI"
                  value={profiling?.monthlyExpenses?.bikeEmi}
                />
              </div>

              {/* School Fees */}
              {profiling?.monthlyExpenses?.schoolFees?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">School Fees</h6>
                  {profiling.monthlyExpenses.schoolFees.map((fee, index) => (
                    <div key={index} className="row">
                      <InfoItem label="Child" value={fee.child} />
                      <InfoItem label="Amount" value={fee.amount} />
                    </div>
                  ))}
                </div>
              )}
              <hr />

              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Trading And Investment
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Trading"
                  value={profiling?.tradingAndInvestment?.trading.join(",")}
                />
                <InfoItem
                  label="Investment"
                  value={profiling?.tradingAndInvestment?.investment.join(",")}
                />
                <InfoItem
                  label="Trading Preferences"
                  value={profiling?.tradingAndInvestment?.tradingPreferences.join(
                    ",",
                  )}
                />
              </div>

              {/* Assets */}
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Assets List
              </h6>
              <div className="row mb-2">
                <InfoItem
                  label="Gold Value"
                  value={profiling?.accetList?.goldValue}
                />
                <InfoItem
                  label="Policy Value"
                  value={profiling?.accetList?.policyValue}
                />
                <InfoItem
                  label="Bank FD Value"
                  value={profiling?.accetList?.bankFdValue}
                />
                <InfoItem
                  label="Cash In Bank"
                  value={profiling?.accetList?.cashInBankValue}
                />
                <InfoItem
                  label="Business Investment"
                  value={profiling?.accetList?.businessInvestmentValue}
                />
                <InfoItem
                  label="Vehicle Value"
                  value={profiling?.accetList?.vehicleCarValue}
                />
              </div>

              {/* Real Estate Assets */}
              {profiling?.assets?.realEstateAssets?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">Real Estate Assets</h6>
                  {profiling.assets.realEstateAssets.map((asset, index) => (
                    <div key={index} className="row">
                      <InfoItem label="Property" value={asset.property} />
                      <InfoItem label="Location" value={asset.location} />
                      <InfoItem label="Type" value={asset.assetType} />
                      <InfoItem label="Value" value={asset.value} />
                    </div>
                  ))}
                </div>
              )}
              <hr />
              <h6 className="mb-1 fw-semibold fs-5 text-decoration-underline">
                Libility List
              </h6>

              {/* Real Estate Assets */}
              {profiling?.libilityList?.length > 0 && (
                <div className="mb-2">
                  <h6 className="mb-1">With type and amount</h6>
                  {profiling.libilityList.map((asset, index) => (
                    <div key={index} className="row">
                      <InfoItem label={asset.type} value={asset.amount} />
                    </div>
                  ))}
                </div>
              )}
              <hr />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Helper component for displaying information items
const InfoItem = ({ label, value }) => (
  <div className="d-flex justify-content-between col-md-6 mb-1">
    <span className="col-6 fw-bold">{label}:</span>
    <span className="col-6 text-capitalize">{value || "N/A"}</span>
  </div>
);

export default LeadDetailsSidebar;
